module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("XsGnP"))).then(() => parcelRequire('hEqeo'));